import { useReadonlyField } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { FormattedDate, FormattedNumber } from 'components/shared/Intl';
import { FC } from 'react';
import { booleanToYesNo } from 'utils/boolean';

import type {
  ProductSummaryCellMetadata,
  ProductSummaryScheduleDatesRow,
  ScheduleDatesCellType,
} from './ScheduleDate.model';

export function fieldForType(type: ScheduleDatesCellType) {
  switch (type) {
    case 'Date':
      return DateCell;
    case 'FixedUnit':
      return FixedUnitCell;
    case 'Amount':
      return AmountCell;
    case 'Text':
      return TextCell;
    case 'Toggle':
      return ToggleCell;
    default:
      return TextCell;
  }
}

export interface ScheduleDatesCellProps {
  scheduleDatesRow: ProductSummaryScheduleDatesRow;
  cellMetadata: ProductSummaryCellMetadata;
}

const DateCell: FC<ScheduleDatesCellProps> = ({ scheduleDatesRow, cellMetadata }) => {
  const cellValue = scheduleDatesRow[cellMetadata.id] as string;
  return <FormattedDate value={new Date(cellValue!)} year="numeric" month="short" day="2-digit" />;
};

const FixedUnitCell: FC<ScheduleDatesCellProps> = ({ scheduleDatesRow, cellMetadata }) => {
  const cellValue = scheduleDatesRow[cellMetadata.id] as number;
  const cellUnit = cellMetadata.unit;
  return cellValue === undefined ? null : (
    <p className="text-large fw-light m-0">
      <FormattedNumber value={cellValue} /> {cellUnit}
    </p>
  );
};

const AmountCell: FC<ScheduleDatesCellProps> = ({ scheduleDatesRow, cellMetadata }) => {
  const cellValue = scheduleDatesRow[cellMetadata.id] as number;
  const { getData } = useReadonlyField();
  const cellUnit = getData(cellMetadata.unitId!);
  return cellValue === undefined ? null : (
    <p className="text-large fw-light m-0">
      <>
        <FormattedNumber value={cellValue} /> {cellUnit}
      </>
    </p>
  );
};

const TextCell: FC<ScheduleDatesCellProps> = ({ scheduleDatesRow, cellMetadata }) => {
  const cellValue = scheduleDatesRow[cellMetadata.id] as string;
  return <p className="text-large fw-light m-0">{cellValue}</p>;
};

const ToggleCell: FC<ScheduleDatesCellProps> = ({ scheduleDatesRow, cellMetadata }) => {
  const cellValue = scheduleDatesRow[cellMetadata.id] as boolean;
  const yesNoValue = booleanToYesNo(cellValue);
  return <p className="text-large fw-light m-0 text-capitalize">{yesNoValue}</p>;
};
